// extracted by mini-css-extract-plugin
export default {"content":"index_content__DeSPi","textRow":"index_textRow__lgwpK","price":"index_price__Ql9io"};